'use client'

/**
 * Shared chain namespace tracker.
 * Used by siwe-config.ts to bypass SIWE for non-EVM chains (solana, tron, ton).
 * Updated by wallet-context.tsx when the active chain changes.
 */

let currentNamespace: string = 'eip155'
let currentAddress: string | null = null

/** Update the tracked chain namespace and optional address */
export function updateChainState(namespace: string, address?: string | null): void {
    currentNamespace = namespace
    if (address !== undefined) currentAddress = address
}

/** Get the current chain namespace */
export function getChainNamespace(): string {
    return currentNamespace
}

/** Get the last-known connected address */
export function getTrackedAddress(): string | null {
    return currentAddress
}

/** Check if the current chain is EVM (eip155) */
export function isEvmNamespace(): boolean {
    return currentNamespace === 'eip155' || currentNamespace === '' || !currentNamespace
}
